import { unescapeHtml } from "@/utils/global";
import { sanitizeHtml } from "@/utils/sanitizeHtml";

// Magento CMS/PageBuilder HTML arrives HTML-entity-encoded and may embed
// {{media url=...}} directives. The one render pipeline for that HTML:
// decode entities -> rewrite media directives to absolute URLs -> sanitize
// last, so nothing produced by the earlier steps can bypass the sanitizer.
//
// Options keep the historical per-page variants byte-identical:
// - mediaCloseToken: the closing token stripped after a quoted directive.
//   Every page uses '"}}"'; static/service-list has always used '"}}'.
// - imgClassPrefix: classes prepended to every <img class="..."> (the
//   certificate pages centre their images this way).
export function buildCmsHtml(
  html,
  { mediaCloseToken = '"}}"', imgClassPrefix } = {}
) {
  let decoded = unescapeHtml(html)
    ?.replaceAll('"{{media url="', `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`)
    ?.replaceAll(`/media/" `, "/media/")
    ?.replaceAll(mediaCloseToken, "")
    ?.replaceAll("{{media url=", `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`)
    ?.replaceAll("}}", "");

  if (imgClassPrefix) {
    decoded = decoded?.replaceAll('<img class="', `<img class="${imgClassPrefix}`);
  }

  return sanitizeHtml(decoded);
}

export default buildCmsHtml;
